// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalEditCredential_modalContainer__1MaMp"};